import { lazy } from 'react';
import Layout from '@/Layouts/Layout';
import { RouteObject } from 'react-router-dom';

// Lazy imports
const NotFound = lazy(() => import('@/pages/Errors/NotFound.page'));
const Partners = lazy(() => import('@/pages/partners/Partners.page'));
const Movie = lazy(() => import('@/pages/projects/Movie'));
const Games = lazy(() => import('@/pages/projects/Games'));
const AmanApp = lazy(() => import('@/pages/projects/AmanApp.page'));
const ContactUs = lazy(() => import('@/pages/contact-us/ContactUs'));
const Blog = lazy(() => import('@/pages/blog/Blog.page'));
const BlogDetails = lazy(() => import('@/pages/blog/BlogDetails'));
// import ComingSoon from '@/pages/comingsoon/ComingSoon';
const Index = lazy(() => import('@/pages/home.page'));
const About = lazy(() => import('@/pages/about/About.page'));
const Projects = lazy(() => import('@/pages/projects/Projects.page'));
const RootRedirect = lazy(() => import('./RootRedirect'));

const routes: RouteObject[] = [
    {
        path: '/',
        element: <RootRedirect />,
    },
    {
        path: '/:lang',
        // element: <ComingSoon />,
        element: <Layout />,
        children: [
            { index: true, element: <Index /> },
            {
                path: 'about',
                element: <About />,
            },
            {
                path: 'partners',
                element: <Partners />,
            },
            {
                path: 'blog',
                element: <Blog />,
            },
            {
                path: 'blog/:id',
                element: <BlogDetails />,
            },
            {
                path: 'projects',
                element: <Projects />,
            },
            {
                path: 'projects/movie/:slug',
                element: <Movie />,
            },
            {
                path: 'projects/series/:slug',
                element: <Movie />,
            },
            {
                path: 'projects/games/:slug',
                element: <Games />,
            },
            {
                path: 'projects/programs/:slug',
                element: <AmanApp />,
            },
            {
                path: 'feedback',
                element: <ContactUs />,
            },
            {
                path: 'contact-us',
                element: <ContactUs />,
            },
            {
                path: '*',
                element: <NotFound />,
            },
        ],
    },
];

export { routes };
